import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["items", "addButton"];
  static values = {
    reorderUrl: String,
    maxItems: { type: Number, default: 12 },
  };

  connect() {
    if (this.hasItemsTarget) {
      this.sortable = Sortable.create(this.itemsTarget, {
        animation: 150,
        handle: "[data-handle]",
        onEnd: () => this._persistOrder(),
      });
    }
    this._refreshAddButton();
  }

  disconnect() {
    this.sortable?.destroy();
  }

  async _persistOrder() {
    const ids = Array.from(this.itemsTarget.querySelectorAll("[data-item-id]"))
      .map((el) => el.dataset.itemId);
    const token = document.querySelector("meta[name=csrf-token]")?.content;
    const formData = new FormData();
    ids.forEach((id) => formData.append("ids[]", id));
    await fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token || "" },
      body: formData,
    });
  }

  _refreshAddButton() {
    if (!this.hasAddButtonTarget) return;
    const count = this.itemsTarget.querySelectorAll("[data-item-id]").length;
    this.addButtonTarget.classList.toggle("hidden", count >= this.maxItemsValue);
  }
}
